export default function Services() {
  return (
    <>
      <h1>Services</h1>
      <p>We offer web development, UI/UX design, and more.</p>
    </>
  );
}
